import React from 'react';
import PropTypes from 'prop-types';

/**
 * A reusable card component for grouping content with a title and optional description
 * 
 * @param {Object} props
 * @param {string} props.title - The title of the card
 * @param {string} [props.description] - Optional description text below the title
 * @param {React.ReactNode} [props.extra] - Optional extra content to display below description
 * @param {React.ReactNode} props.children - The main content of the card
 * @param {string} [props.className] - Additional CSS classes to apply to the card
 * @param {Object} [props.style] - Additional inline styles to apply to the card
 */
export default function CardGroup({ 
  title, 
  description, 
  extra, 
  children, 
  className = '',
  style = {}
}) {
  return (
    <div 
      className={`card-theme ${className}`} 
      style={{ marginBottom: 32, ...style }}
    >
      {(title || description || extra) && <div style={{ marginBottom: 18 }}>
        {title && <div style={{ 
          fontWeight: 'bold', 
          fontSize: '1.2rem', 
          color: '#fff', 
          marginBottom: description ? 4 : 0 
        }}>
          {title}
        </div>}
        {description && (
          <div style={{ 
            color: '#b5b5b5', 
            fontSize: '1rem', 
            marginBottom: 12 
          }}>
            {description}
          </div>
        )}
        {extra && (
          <div style={{ marginBottom: 12 }}>
            {extra}
          </div>
        )}
      </div>}
      {children}
    </div>
  );
}

CardGroup.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  extra: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
}; 